import { t as lnT } from '../../i18n';
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (typeof window !== 'undefined' && window.__showLuckynoteStartupError) {
            window.__showLuckynoteStartupError(error?.stack || error?.message || String(error));
        }
        // Log error to console for debugging
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <h2 style={styles.title}>{lnT('errors:somethingWentWrong')}</h2>
                        <p style={styles.message}>{lnT('errors:theAppEncounteredAnErrorPleaseTry')}</p>
                        <button onClick={this.handleReload} style={styles.button}>{lnT('errors:reloadPage')}</button>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div style={styles.details}>
                                <h3 style={styles.detailsTitle}>{lnT('errors:errorDetailsDevelopmentOnly')}</h3>
                                <pre style={styles.detailsText}>
                                    {this.state.error.toString()}
                                </pre>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 20
    },
    content: {
        textAlign: 'center',
        maxWidth: 500,
        padding: 40,
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        color: '#333',
        margin: '0 0 16px'
    },
    message: {
        fontSize: 16,
        color: '#666',
        margin: '0 0 24px',
        lineHeight: 1.5
    },
    button: {
        backgroundColor: '#2b88d9',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '12px 24px',
        fontSize: 16,
        fontWeight: 600,
        cursor: 'pointer'
    },
    details: {
        marginTop: 32,
        paddingTop: 32,
        borderTop: '1px solid #e0e0e0',
        textAlign: 'left'
    },
    detailsTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#333',
        margin: '0 0 8px'
    },
    detailsText: {
        fontSize: 12,
        color: '#666',
        backgroundColor: '#f5f5f5',
        padding: 12,
        borderRadius: 4,
        overflowX: 'auto',
        margin: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    }
};

export default ErrorBoundary;
